/*
Usage Notes: 

The following web component can be dropped into any standard Shopify theme (i.e. non-headless), using Liquid to pass product data:

  <skio-plan-picker 
    product='{{ product | json | escape }}'
    selectedVariant='{{ product.selected_or_first_available_variant | json | escape }}'
    formId='{{ product_form_id }}'
    >
  </skio-plan-picker>
  <script src="{{ 'skio-plan-picker-component.js' | asset_url }}" type="module"></script>

  Note: formId not required if element is inside of a form already
*/

// LitJS is <5kb minified and gzipped, and is the only dependency for this component
import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js';
var cls=$('body').attr('class')

if(cls.indexOf('CA') !== -1){
  var items=''
}else{
  var items='+ Free Shipping'
}
 

 
const skioStyles = css`
  .skio-plan-picker {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 0;
    border: 0;
    font-family: inherit;
    margin-top: 1rem;
  }

  .skio-onetime-second {
    order: 2;
  }
  
  .skio-group-container {
    display: none;
  }

  .skio-group-container--available {
    display: block;
    justify-content: center;
    position: relative;
    border-radius: 12px;
    border-width: 2px;
    border-color: #1f2a27;
    border-style: solid; 
    transition: border-color 0.2s ease;
    padding: 1rem 1rem;
    background: white;
    margin-bottom: 20px;
  }

  .skio-group-container--available.one-time {
      margin-bottom: 30px;
    }

  .skio-group-container--selected {
    background-color: #aafdb1;
    border-color: #1f2a27;
  }

  .skio-group-container--most-popular:after {
    content: 'Community Favourite';
    position: absolute;
    top: 4px;
    left: 0;
    right: 0;
    margin: auto;
    transform: translateY(-100%);
    background: #1a2c27;
    letter-spacing: 2px;
    font-size: 8px;
    text-align: center;
    font-weight: normal;
    text-transform: uppercase;
    color: white;
    padding: 6px 6px 1rem 6px;
    border-radius: 12px 12px 0 0;
    z-index: -1;
  }
  .skio-group-container--biggest-popular:after {
    content: 'Biggest Savings';
    position: absolute;
    top: 4px;
    left: 0;
    right: 0;
    margin: auto;
    transform: translateY(-100%);
    background: #ef6829;
    letter-spacing: 2px;
    font-size: 8px;
    text-align: center;
    font-weight: normal;
    text-transform: uppercase;
    color: white;
    padding: 6px 6px 1rem 6px;
    border-radius: 12px 12px 0 0;
    z-index: -1;
  }

  span.sub-price {
    white-space: nowrap;
  }
  
  .skio-group-input {
    position: absolute;
    width: 0px;
    height: 0px;
    opacity: 0;
  }

  .skio-group-input:focus-visible ~ .skio-group-label {
    outline: 2px #ccc solid;
    outline-offset: 4px;
    border-radius: 5px;
  }
  
  .skio-group-label {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    overflow: hidden;
  }
  
  .skio-group-topline {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    font-size: 13px;
    justify-content: center;
    text-align: center;
    gap: 12px;
    font-weight: 600;
    line-height: 1.5;
  }

  .skio-group-subtitle {
    color: #ef6829;
    letter-spacing: 2px;
    font-size: 8px;
    line-height: 1;
  }
  
  .skio-price {
    font-weight: 600;
    color: #163316;
    font-size: 15px;
  }
  
  .skio-group-title {
    min-width: max-content;
  }
  
  .skio-save {
    padding: 0.25rem 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    transform: translateY(-50%);
    width: 80%;
    letter-spacing: 2px;
    font-size: 8px;
    font-weight: 600;
    text-transform: uppercase;
    border: 0px solid #163316;
    text-align: center;
    border-radius: 12px;
    background: #aafdb1;
  }

  .skio-group-container--selected .skio-save {
    background: #cbf5bd;
    border-color: transparent;
  }

  @media(min-width: 600px) {
    .skio-plan-picker {
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
      margin-top: 3rem;
    }

    .skio-group-container--available.one-time {
      margin-bottom: 20px;
    }
  }

  @media(min-width: 768px) {
    .skio-plan-picker {
      grid-template-columns: 1fr;
      gap: 20px;
      margin-top: 1rem;
    }

    .skio-group-container--available.one-time {
      margin-bottom: 30px;
    }
  }

  @media(min-width: 1200px) {
    .skio-plan-picker {
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
      margin-top: 3rem;
    }

    .skio-group-container--available.one-time {
      margin-bottom: 20px;
    }
  }
`;

export class SkioPlanPickerComponent extends LitElement {
  static properties = {
    product: { type: Object },            //required
    productHandle: { type: String },      //optional (unless product isn't passed, then required)
    key: { type: String },                //optional, defaults to product.id; identifier for this instance of the Skio plan picker

    subscriptionFirst: { type: Boolean }, //optional, defaults to false; if true, shows subscription option above onetime
    startSubscription: { type: Boolean }, //optional, defaults to false; if true, auto-selects subscription on page load
    hideSelect: { type: Boolean }, // optional, defaults to false; if true, hides the select dropdown
    discountFormat: { type: String },     //optional, defaults to percent; can also pass "fixed"
    
    currency: { type: String },           //optional, defaults to 'USD', but can pass any 3 char identifier
    language: { type: String },           //optional, defaults to 'en-US', but can pass any similarly formatted language identifier
    moneyFormatter: {},                   //placeholder for object
  
    selectedVariant: { type: Object },    //placeholder for data
    skioSellingPlanGroups: {},            //placeholder for data
    availableSellingPlanGroups: {},       //placeholder for data
    selectedSellingPlanGroup: {},         //placeholder for data
    selectedSellingPlan: {},              //placeholder for data
  };

  static styles = skioStyles;

  constructor() {
    super();
    
    this.product = null;
    this.selectedVariant = null;

    this.productHandle = null;

    this.key = null;

    this.skioSellingPlanGroups = null;
    this.availableSellingPlanGroups = null;

    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;

    this.startSubscription = false;
    this.subscriptionFirst = false;
    this.hideSelect = false;

    this.skioMainProduct = true;

    this.discountFormat = 'percent';

    this.currency = 'USD';
    this.language = 'en-US';
    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: 'currency',
      currency: this.currency,
    });
  }

  connectedCallback() {
    super.connectedCallback();

    if(!this.product && this.productHandle) {
      this.fetchProduct(this.productHandle);
    }

    const form = this.closest('form');
    console.log('skio', form)
    if(form) {
      const variantInput = form.querySelector('button.add-to-cart');
      if(variantInput) {
        variantInput.addEventListener('change', () => {
          this.selectedVariant = this.product.variants.find(variant => variant.id == variantInput.dataset.id);
        });
      }
    }
  }

  render() {
    if(!this.product || !this.selectedVariant) return;
    
    return html`
      <fieldset class="skio-plan-picker" skio-plan-picker="${ this.key }">
        <div class="skio-group-container one-time ${ this.product.requires_selling_plan == false ? 'skio-group-container--available' : '' } ${ this.selectedSellingPlanGroup == null ? 'skio-group-container--selected' : '' } ${ this.subscriptionFirst ? 'skio-onetime-second' : ''}" skio-group-container 
          @click=${() => this.selectSellingPlan(null) } >
        
          <input id="skio-one-time-${ this.key }" class="skio-group-input" name="skio-group-${ this.key }" type="radio" value="" 
            skio-one-time ?checked=${ this.startSubscription == false && this.product.requires_selling_plan == false ? true : false }>
          <label class="skio-group-label" for="skio-one-time-${ this.key }">
            <div class="skio-group-topline">
              <div class="skio-group-title">
                One Time Purchase
              </div>
              <div class="skio-price">
                <span skio-onetime-price>${ this.moneyFormatter.format(this.selectedVariant.price / 100) }</span><br/>
                <span style="display: none;font-weight: normal; font-size: 85%;">${ this.moneyFormatter.format(this.selectedVariant.price / 100 / 30) }/per day</span>
              </div>
              <span class="skio-group-subtitle" style="font-weight: 600;display: none"><b>+ Free Shipping</b></span>
              <span class="skio-group-subtitle" style="display: none">Pause/Cancel Anytime</span>
            </div>
          </label>
        </div>

        ${ this.availableSellingPlanGroups ? this.availableSellingPlanGroups.map((group, index) => 
          group.available_selling_plans.map((selling_plan, index) => 
            html`
            <div class="skio-group-container skio-group-container--available ${ this.selectedSellingPlan == selling_plan ? 'skio-group-container--selected' : '' } ${ selling_plan.name.includes('1-Month') ? 'skio-group-container--most-popular' : ''} ${ selling_plan.name.includes('3-Month') ? 'skio-group-container--biggest-popular' : ''}" skio-group-container
              @click=${() => this.selectSellingPlan(selling_plan) }>
              <input id="skio-selling-plan-group-${ index }-${ this.key }" class="skio-group-input" name="skio-group-${ this.key }"
                type="radio" value="${ group.id }" skio-selling-plan-group="${ group.id }" ?checked=${ this.selectedSellingPlanGroup == group ? true : false } >
              <label class="skio-group-label" for="skio-selling-plan-group-${ index }-${ this.key }">
                ${ this.discount(selling_plan).amount && this.discount(selling_plan).percent !== '0%' ? html`
                      <span class="skio-save">${ this.discountFormat == 'percent' ? this.discount(selling_plan).percent : this.discount(selling_plan).amount } Saving</span>
                ` : html`` }
                <div class="skio-group-topline">
                  <div class="skio-group-title">
                    ${ selling_plan.name.includes('3-Month') ? 'Best Results' : 'Most Popular'}
                    <br/>
                    ${ selling_plan.name.includes('3-Month') ? '3-Month Supply' : 'Subscribe & Save'}
                  
                  </div>
                  <div class="skio-price">
                    <span class="sub-price" skio-subscription-price>
                    <span style="font-weight: normal; color: #666;"><s>${this.money(this.selectedVariant.price)}</s> </span>
                    ${ this.price(selling_plan) }</span>
                    <span style="display: none;font-weight: normal; font-size: 85%;">${ this.money( ( this.selectedVariant.price - this.discount(selling_plan).amount) / 30 )  }/per day</span>
                  </div>
                  <span class="skio-group-subtitle" style="font-weight: 600;">${items}</span>
                    <span class="skio-group-subtitle" style="font-weight: 600 "><b>+ Exclusive   Deals
</b><br><br>+ Free Gifts</span>
                  <span    class=" skio-group-subtitle">${ selling_plan.name.includes('3-Month') ? 'Pause/Cancel after 3-Months' : 'Pause/Cancel Anytime'}</span>
                 
                </div>
              </label>
            </div>
          `
          )
        ): ''}
      </fieldset>`
  }

  updated = (changed) => {
    if(changed.has('product') && this.product) {
      //update key
      this.key = this.key ? this.key : this.product.id;

      //update skioSellingPlanGroups
      this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(
        selling_plan_group => selling_plan_group.app_id === 'SKIO'
      )
    }

    if(changed.has('selectedVariant') && this.selectedVariant) {
      //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      this.availableSellingPlanGroups = this.skioSellingPlanGroups.filter(selling_plan_group =>
        selling_plan_group.selling_plans.some(selling_plan =>
          this.selectedVariant.selling_plan_allocations.some(
            selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id
          )
        )
      )

      //update selectedSellingPlan value
      if (this.availableSellingPlanGroups?.length > 0) {
        //update each group with a default selected_selling_plan
        this.availableSellingPlanGroups.forEach((group => {
          group.available_selling_plans = group.selling_plans.filter(selling_plan =>
            this.selectedVariant.selling_plan_allocations.some(
              selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id
            )
          );

          group.selected_selling_plan = group.available_selling_plans[0];
          group.available_selling_plans = group.available_selling_plans.sort((a, b) => {
            if(a.name.includes('1-Month') && !b.name.includes('1-Month')) return -1;
            return 1;
          });
        }));

        if(this.startSubscription == true || this.product.requires_selling_plan == true) {
          this.selectedSellingPlanGroup = this.availableSellingPlanGroups[0];
          this.selectedSellingPlan = this.availableSellingPlanGroups[0].available_selling_plans[1];
        } else {
          this.selectedSellingPlan = null;
          this.selectedSellingPlanGroup = null
        }
      } else {
        this.selectedSellingPlan = null;
        this.selectedSellingPlanGroup = null
      }

      this.updateForm();
      this.updateAddToCartButton();
    }

    if(changed.has('selectedSellingPlan')) {
      //update price of price elements if applicable
      document.querySelectorAll(`[skio-price][skio-key="${ this.key }"]`).forEach((el) => {
        el.innerHTML = this.price(this.selectedSellingPlan);
      });

      //update display of external content elements
      document.querySelectorAll(`[skio-onetime-content][skio-key="${ this.key }"]`).forEach((el) => {
        this.selectedSellingPlan !== null ? el.style.display = "none" : el.style.removeProperty('display');
      });

      document.querySelectorAll(`[skio-subscription-content][skio-key="${ this.key }"]`).forEach((el) => {
        this.selectedSellingPlan == null ? el.style.display = "none" : el.style.removeProperty('display');
      });

      //dispatch CustomEvent to tell that this specific plan picker was updated, and pass the selectedSellingPlan
      const event = new CustomEvent(`skio::update-selling-plan`, {
        bubbles: true, 
        composed: true, 
        detail: {
          variant: this.selectedVariant,
          sellingPlan: this.selectedSellingPlan,
          key: this.key
        }
      });

      this.dispatchEvent(event);

      let sellingPlanInput = document.querySelector('input[name="selling_plan"]')
      this.selectedSellingPlan != null ? sellingPlanInput.value = this.selectedSellingPlan.id : sellingPlanInput.value = ''

      this.updateForm();
      this.updateAddToCartButton();
    }
  }

  log = (...args) => {
    args.unshift('%c[skio]', 'color: #8770f2;');
    console.log.apply(console, args);
  }

  error = (...args) =>  {
    args.unshift('%c [skio]', 'color: #ff0000');
    console.error.apply(console, args);
  }
  
  // Update selected selling plan group; called on click of skio-group-container element
  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group;
    this.selectedSellingPlan = group?.selected_selling_plan;

    //update the form that was passed, if any
    this.updateForm();
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlan(selling_plan) {
    if(!selling_plan) {
      this.selectedSellingPlanGroup = null;
      this.selectedSellingPlan = null;
    } else {
      const group = this.availableSellingPlanGroups.find(group => group.available_selling_plans.find(plan => plan == selling_plan));

      let sellingPlan = group.available_selling_plans.find(plan => plan.id == selling_plan.id);
      if (sellingPlan) {
        group.selected_selling_plan = sellingPlan;
        this.selectedSellingPlanGroup = group;
        this.selectedSellingPlan = sellingPlan;
      }
      else this.log("Error: couldn't find selling plan with id " + element.value + " for variant " + this.selectedVariant.id + " from product " + this.product.id + " : " + this.product.handle);
    }
  }

  // Formats integer value into money value
  money(price) {
    return this.moneyFormatter.format(price / 100.0)
  }

  

  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discount(selling_plan) {
    if (!selling_plan)
      return { percent: '0%', amount: 0 }
    
    const price_adjustment = selling_plan.price_adjustments[0]
    const discount = { percent: '0%', amount: 0 }
    const price = this.selectedVariant.price;
    
    switch (price_adjustment.value_type) {
      case 'percentage':
        discount.percent = `${price_adjustment.value}%`
        discount.amount = Math.round(
          (price * price_adjustment.value) / 100.0
        )
        break
      case 'fixed_amount':
        discount.percent = `${Math.round(
          ((price_adjustment.value * 1.0) / price) * 100.0
        )}%`
        discount.amount = price_adjustment.value
        break
      case 'price':
        discount.percent = `${Math.round(
          (((price - price_adjustment.value) * 1.0) /
            price) *
            100.0
        )}%`
        discount.amount = price - price_adjustment.value
        break
    }
    
    return discount
  }

  // Calculates the variant's price for the given selling plan, returns a formatted money value (if desired)
  price(selling_plan, formatted = true) {
    return formatted
      ? this.money( this.selectedVariant.price - this.discount(selling_plan).amount)
      :  this.selectedVariant.price - this.discount(selling_plan).amount
  }

  // Updates element data to be registered by forms
  updateForm() {
    let $sellingPlan = this.querySelector('input[name=selling_plan]');
    if($sellingPlan) { 
      $sellingPlan.value = this.selectedSellingPlan ? this.selectedSellingPlan.id : '';
      $sellingPlan.dispatchEvent(new Event('change'));
    }
  }

  updateAddToCartButton() {
    const $addToCartButton = this.closest('form').querySelector('.add-to-cart');
    if(!$addToCartButton) return;

    const $addToCartButtonPrice = $addToCartButton.querySelector('.price');
    if(!$addToCartButtonPrice) return;
    
    if(this.selectedSellingPlan) {
      $addToCartButtonPrice.innerHTML = this.moneyFormatter.format((this.selectedVariant.price - this.discount(this.selectedSellingPlan).amount) / 100);
    } else {
      $addToCartButtonPrice.innerHTML = this.moneyFormatter.format(this.selectedVariant.price / 100);
    }
  }

  // Optional functions keep if necessary 

  /**
   *   
   * 
   */
  
  // Runs a fetch request to add the selectedVariant to the cart with the passed quantity and selectedSellingPlan
  addToCart(quantity) {
    const items = [
      {
        id: this.selectedVariant.id,
        quantity: quantity,
        ...(this.selectedSellingPlan && { selling_plan: this.selectedSellingPlan?.id })
      }
    ];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    })
    .then((response) => response.json())
    .then((response) => {
      this.log("SKIO added item to cart: ", response);
      //dispatch CustomEvent to tell document that an item was added to cart
      const event = new CustomEvent(`skio::added-to-cart`, {
        bubbles: true, 
        composed: true, 
        detail: {
          response,
          key: this.key
        }
      });

      this.dispatchEvent(event);
    })
    .catch((error) => {
      this.error(`SKIO ${ this.key } error adding item to cart: `, error);
    });
  } 

  fetchProduct = (handle) => {
    return fetch(`/products/${ handle }.js`)
    .then((response) => response.json())
    .then((product) => {
      this.product = product;
      this.selectedVariant = product.variants[0];

      return product;
    });
  }
}

 
customElements.define('skio-plan-picker', SkioPlanPickerComponent);